import React from 'react';
import { Grid, Typography, Card, CardHeader, CardActions, CardMedia, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import ShareIcon from '@mui/icons-material/Share';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import homestyles from  "../../css/homestyles.module.css"
import image from "../../images/brand/zen_book_extreme_close_up_of_ligthouse_with_painted_with_red_an_f7464904-ea5b-4b10-abac-ac5c250e653a.webp"


const HomeBlogCard = () => {

    return (
    <Grid container spacing={2} >
        <Grid item xs={1} sm={2} md={2} lg={2} xl={2}/>
        <Grid item xs={9} sm={7} md={7} lg={7} xl={7}>
            <Link to='blogentry'> 
                <Card className={homestyles["card"]}>
                    <CardHeader 
                    title={"FEATURED ARTICLE"}
                    subheader={"March 17, 2024"}
                    Typography={"h6"}
                    action={
                        <IconButton aria-label="settings">
                        <MoreVertIcon />
                        </IconButton>
                    }
                    />
                    <CardMedia
                        component="img"
                        height="194"
                        image={image}
                        alt="Lighthouse side"
                    />                        
                    <CardActions disableSpacing>
                        <IconButton aria-label="share">
                            <ShareIcon />
                        </IconButton>
                    </CardActions>
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            The shores of Galilee commonplace in commercial trade, but also served as 
                            a key location for Christ's preaching, a beacon for the coming spread of the Gospel to 
                            the four winds of the earth. 
                        </Typography>
                    </CardContent>
                </Card>
            </Link>
        </Grid>
        <Grid item xs={1} sm={3} md={3} lg={3} xl={3}/>
    </Grid>
    )
}

export default HomeBlogCard